module.exports = __webpack_public_path__ + "static/HowTheExtensionWorks@2x-52c48791ae26329ef61ba4e8c35708fb.png";